import type { AuthUserFieldsFragment } from '~/graphql/generated/graphql';

import { RoleType } from '~/graphql/generated/graphql';

export default defineNuxtRouteMiddleware(async (to) => {
  const { requiredRoleType } = to.meta;

  if (!requiredRoleType) {
    return;
  }

  const platformAppConfig = usePlatformAppConfig(to.path);

  const { isLoggedIn, user } = useAuthStore();

  if (!isLoggedIn || !user) {
    return await navigateTo(clusterRedirectPath(platformAppConfig.unAuthenticatedRedirectRoute), { replace: true });
  }

  const roleGuards: Record<RoleType, (user: AuthUserFieldsFragment) => boolean> = {
    [RoleType.Admin]: (user: AuthUserFieldsFragment) => user.adminRoles.length > 0,
    [RoleType.Student]: (user: AuthUserFieldsFragment) => user.studentRoles.length > 0,
    [RoleType.Teacher]: (user: AuthUserFieldsFragment) => user.teacherRoles.length > 0,
  };

  const anyChecksPass = requiredRoleType.some((roleType) => {
    return roleGuards[roleType](user);
  });

  if (!anyChecksPass) {
    return await navigateTo(clusterRedirectPath(platformAppConfig.dashboardRedirectRoute), { replace: true });
  }

  return true;
});
